import { getDefaultClient } from '../../../../client/defaultClient';
import { getWalletProviderFromWalletAccount } from '../../utils/getWalletProviderFromWalletAccount';
import type { WalletAccount } from '../../walletAccount';
import { getNetworksData } from '../getNetworksData';

type GetActiveNetworkDataParams = {
  walletAccount: WalletAccount;
};

/**
 * Retrieves the network configuration data for the currently active network.
 *
 * This function returns detailed network information including RPC URLs,
 * native currency details, and block explorer URLs for the network that
 * the wallet account is currently connected to.
 *
 * @param params.walletAccount - The wallet account to get network data for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the network data, or undefined if not found.
 */
export const getActiveNetworkData = async (
  { walletAccount }: GetActiveNetworkDataParams,
  client = getDefaultClient()
) => {
  const walletProvider = getWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  const { networkId } = await walletProvider.getActiveNetworkId();

  const networksData = getNetworksData(client);

  const activeNetworkData = networksData.find(
    (data) =>
      data.networkId === networkId && data.chain === walletProvider.chain
  );

  return { networkData: activeNetworkData };
};
